import {useDispatch} from "react-redux";
import {closeMenu} from "../../models/menu/actions";

import { ReactComponent as CloseIcon } from './assets/images/close.svg'

import c from './assets/sass/mobileMenu.module.scss'

const MobileMenu = () => {
    const dispatch = useDispatch()

    const closeHandler = () => {
        dispatch(closeMenu())
    }

    const scrollToPrice = (e) => {
        e.preventDefault()
        dispatch(closeMenu())

        document.getElementById('price')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToAbout = (e) => {
        e.preventDefault()
        dispatch(closeMenu())

        document.getElementById('about')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToReviews = (e) => {
        e.preventDefault()
        dispatch(closeMenu())

        document.getElementById('reviews')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    const scrollToContacts = (e) => {
        e.preventDefault()
        dispatch(closeMenu())

        document.getElementById('contacts')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        })
    }

    return (
        <div className={c.component}>
            <div className={c.block}>
                <button className={c.close} onClick={closeHandler}>
                    <CloseIcon className={c.closeIcon}/>
                </button>
                <nav>
                    <ul className={c.list}>
                        <li>
                            <button className={c.button} onClick={scrollToPrice}>
                                Услуги/Цены
                                <span>14</span>
                            </button>
                        </li>
                        <li>
                            <button className={c.button} onClick={scrollToAbout}>
                                О студии
                            </button>
                        </li>
                        <li>
                            <button className={c.button} onClick={scrollToReviews}>
                                Отзывы
                            </button>
                        </li>
                        <li>
                            <button className={c.button} onClick={scrollToContacts}>
                                Контакты
                            </button>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}

export default MobileMenu
